export const GET_ALL_REVENUE_PLAN_TEAMSALE = `query GetAllRevenueTteamsales($input:TrevenueTteamsalesWhereInput,$skip:Float,$take:Float){
    getRevenueTteamsales(where:$input,skip:$skip,take:$take,orderBy:{typeRevenue: ASC,teamSalesId:ASC}){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            plantId
            typeRevenue
            ttypeRevenue{
                name
            }
            teamSalesId
            totalYearSaleamt
            year
            status
            perDensity
            janSaleamt
            febSaleamt
            marSaleamt
            aprSaleamt
            maySaleamt
            junSaleamt
            julSaleamt
            augSaleamt
            octSaleamt
            sepSaleamt
            novSaleamt
            decSaleamt
            tteamSales{
                subId
                name
            }
            createDate
            modifyDate
            tcreateUser{
                fullName
            }
            tmodifyUser{
                fullName
            }
        }
    }
}
`;
export const Create_Revenue_Plan_TeamSale = `mutation CreateRevenueTteamsales($input:TrevenueTteamsalesInput!){
    createRevenueTteamsales(input:$input){
            id
            plantId
            totalYearSaleamt
            year
            typeRevenue
            janSaleamt
            febSaleamt
            marSaleamt
            aprSaleamt
            maySaleamt
            junSaleamt
            julSaleamt
            augSaleamt
            sepSaleamt
            octSaleamt
            novSaleamt
            decSaleamt
    }
}

`;
export const Import_Revenue_Plan_TeamSale = `mutation CreateRevenuePlanTeamSaleById($input: [TrevenuePlanTteamsaleInput!]!) {
  createManyRevenuePlanTteamsale(input: $input) {
    id
    aprSaleamt
    aprProfitSaleamt
    augSaleamt
    augProfitSaleamt
    plantId
    teamSaleId
    decProfitSaleamt
    decSaleamt
    febProfitSaleamt
    febSaleamt
    janProfitSaleamt
    janSaleamt
    julProfitSaleamt
    julSaleamt
    junProfitSaleamt
    junSaleamt
    marProfitSaleamt
    marSaleamt
    mayProfitSaleamt
    maySaleamt
    novProfitSaleamt
    novSaleamt
    octProfitSaleamt
    octSaleamt
    sepProfitSaleamt
    sepSaleamt
    totalYearSaleamt
    unitMoney
    grossProfitPlanAmt
    netRevenuePlanAmt
    createId
    year
  }
}

`;
export const Update_Revenue_Plan_TeamSale = `
mutation UpdateRevenueTteamsales($input:TrevenueTteamsalesInput!){
    updateRevenueTteamsales(input:$input){
            id
            plantId
            totalYearSaleamt
            year
    }
}
`;
export const Check_Revenue_Plan_TeamSale_is_exist = `
query GetAllRevenuePlanTeamSale(
  $input: TrevenuePlanTteamsaleWhereInput
  $skip: Float
  $take: Float
) {
  getRevenuePlanTteamsale(where: $input, skip: $skip, take: $take, orderBy:{year: DESC}) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
      id
      plantId
      teamSaleId
      year
    }
  }
}
`;

export const GET_REVENUE_TEAMSALE_OF_USER = `
  query GetRevenueTeamsaleOfUser(
    $input: VRevenueTeamsaleOfUserViewWhereInput!
    $skip: Float
    $take: Float
  ) {
    getRevenueTeamsaleOfUserView(where:$input,skip:$skip,take:$take){
      pageInfo{
          currentPage
          hasNextPage
          hasPreviousPage
          itemsPerPage
          totalItems
          totalPages
      }
      items{
        id
        userId
        aprSaleamt
        aprProfitSaleamt
        plantId
        teamSaleId
        augSaleamt
        augProfitSaleamt
        plantId
        tplant{
          name
          areaName
          companyName
        }
        tteamSale {
          id
          name
        }
        approval {
          id
          fullName
          avatar
        }
        decProfitSaleamt
        decSaleamt
        febProfitSaleamt
        febSaleamt
        janProfitSaleamt
        janSaleamt
        julProfitSaleamt
        julSaleamt
        junProfitSaleamt
        junSaleamt
        marProfitSaleamt
        marSaleamt
        mayProfitSaleamt
        maySaleamt
        novProfitSaleamt
        novSaleamt
        octProfitSaleamt
        octSaleamt
        sepProfitSaleamt
        sepSaleamt
        totalYearSaleamt
        unitMoney
        year
        createDate
        createId
        grossProfitPlanAmt
        netRevenuePlanAmt
        tcreateUser{
          fullName
        }
        modifyDate
        tmodifyUser{
          fullName
        }
      }
    }
  }
`;
export const GET_REVENUE_TEAMSALE_BY_PLANTID_YEAR = `query GetAllRevenuePlanTeamSale(
  $input: TrevenuePlanTteamsaleWhereInput
  $skip: Float
  $take: Float
) {
  getRevenuePlanTteamsale(where: $input, skip: $skip, take: $take, orderBy:{year: DESC}) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items{
        teamSaleId
        year
        plantId
        totalYearSaleamt
    }
  }
}
`;
//GetTypeRevenueComBoBox
export const GET_TYPE_REVENUE_COMBOBOX = `query GetTypeRevenueComBoBox($input:TcodeWhereInput,$skip:Float,$take:Float){
    getCode(where:$input,skip:$skip,take:$take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            name
        }
    }
} `;
export const CHECK_EXISTED_REVENUE_TEAMSALE = `query CheckExistedRevenueTeamSale($input:TrevenueTteamsalesWhereInput){
    getRevenueTteamsales(where:$input){
        items{
            id
            plantId
            teamSalesId
            typeRevenue
            year
        }
    }
}`;

// get Track Revenue Team sales
export const GET_TRACK_REVENUE_TEAMSALE = `
  query GetTrackRevenueTeamSale($input: RevenueTeamsaleInput!, $skip: Float!, $take: Float!){
      getTrackRevenueTeamSale(input: $input, skip: $skip, take: $take){
          pageInfo{
              hasNextPage
              hasPreviousPage
              itemsPerPage
              currentPage
              totalItems
              totalPages
          }
          items{
              year
              plant_id
              plant_name
              team_sales_id
              team_sales_name
              team_sub_id
              type_revenue
              cumulative_plan
              year_plan
              realized_revenue
              cumulative_plan_percent
              percentage_achieved_year
              unit_money
              modify_name
              modify_date
          }
      }
  }
`;

// get Track Revenue TeamSales Detail
export const GET_TRACK_REVENUE_TEAMSALES_DETAIL = `query GetTrackRevenueHo($input: RevenueHoTeamsaleDetailInput!){
    getTrackRevenueDetailTeamSale(input: $input){
       process_revenue{
        revenue_plant{
            plant_name
            team_sales_id
            team_name
            type_revenue
            month_revenue_1
            month_revenue_2
            month_revenue_3
            month_revenue_4
            month_revenue_5
            month_revenue_6
            month_revenue_7
            month_revenue_8
            month_revenue_9
            month_revenue_10
            month_revenue_11
            month_revenue_12
            total_year_revenue
            type_revenue_actual_1
            month_revenue_actual_1
            month_revenue_actual_2
            month_revenue_actual_3
            month_revenue_actual_4
            month_revenue_actual_5
            month_revenue_actual_6
            month_revenue_actual_7
            month_revenue_actual_8
            month_revenue_actual_9
            month_revenue_actual_10
            month_revenue_actual_11
            month_revenue_actual_12
            total_year_revenue_actual
            month_percent_1
            month_percent_2
            month_percent_3
            month_percent_4
            month_percent_5
            month_percent_6
            month_percent_7
            month_percent_8
            month_percent_9
            month_percent_10
            month_percent_11
            month_percent_12
            total_year_percent
        }
        total_month_revenue_1
        total_month_revenue_2
        total_month_revenue_3
        total_month_revenue_4
        total_month_revenue_5
        total_month_revenue_6
        total_month_revenue_7
        total_month_revenue_8
        total_month_revenue_9
        total_month_revenue_10
        total_month_revenue_11
        total_month_revenue_12
        total_year_revenue
        total_month_revenue_actual_1
        total_month_revenue_actual_2
        total_month_revenue_actual_3
        total_month_revenue_actual_4
        total_month_revenue_actual_5
        total_month_revenue_actual_6
        total_month_revenue_actual_7
        total_month_revenue_actual_8
        total_month_revenue_actual_9
        total_month_revenue_actual_10
        total_month_revenue_actual_11
        total_month_revenue_actual_12
        total_revenue_year_actual
        total_month_percent_1
        total_month_percent_2
        total_month_percent_3
        total_month_percent_4
        total_month_percent_5
        total_month_percent_6
        total_month_percent_7
        total_month_percent_8
        total_month_percent_9
        total_month_percent_10
        total_month_percent_11
        total_month_percent_12
        total_year_percent
       }
       profit_revenue{
            revenue_plant{
                plant_name
                team_sales_id
                team_name
                type_revenue
                month_revenue_1
                month_revenue_2
                month_revenue_3
                month_revenue_4
                month_revenue_5
                month_revenue_6
                month_revenue_7
                month_revenue_8
                month_revenue_9
                month_revenue_10
                month_revenue_11
                month_revenue_12
                total_year_revenue
                type_revenue_actual_1
                month_revenue_actual_1
                month_revenue_actual_2
                month_revenue_actual_3
                month_revenue_actual_4
                month_revenue_actual_5
                month_revenue_actual_6
                month_revenue_actual_7
                month_revenue_actual_8
                month_revenue_actual_9
                month_revenue_actual_10
                month_revenue_actual_11
                month_revenue_actual_12
                total_year_revenue_actual
                month_percent_1
                month_percent_2
                month_percent_3
                month_percent_4
                month_percent_5
                month_percent_6
                month_percent_7
                month_percent_8
                month_percent_9
                month_percent_10
                month_percent_11
                month_percent_12
                total_year_percent
            }
            total_month_revenue_1
            total_month_revenue_2
            total_month_revenue_3
            total_month_revenue_4
            total_month_revenue_5
            total_month_revenue_6
            total_month_revenue_7
            total_month_revenue_8
            total_month_revenue_9
            total_month_revenue_10
            total_month_revenue_11
            total_month_revenue_12
            total_year_revenue
            total_month_revenue_actual_1
            total_month_revenue_actual_2
            total_month_revenue_actual_3
            total_month_revenue_actual_4
            total_month_revenue_actual_5
            total_month_revenue_actual_6
            total_month_revenue_actual_7
            total_month_revenue_actual_8
            total_month_revenue_actual_9
            total_month_revenue_actual_10
            total_month_revenue_actual_11
            total_month_revenue_actual_12
            total_revenue_year_actual
            total_month_percent_1
            total_month_percent_2
            total_month_percent_3
            total_month_percent_4
            total_month_percent_5
            total_month_percent_6
            total_month_percent_7
            total_month_percent_8
            total_month_percent_9
            total_month_percent_10
            total_month_percent_11
            total_month_percent_12
            total_year_percent
       }
       invoice_revenue{
            revenue_plant{
                plant_name
                team_sales_id
                team_name
                type_revenue
                month_revenue_1
                month_revenue_2
                month_revenue_3
                month_revenue_4
                month_revenue_5
                month_revenue_6
                month_revenue_7
                month_revenue_8
                month_revenue_9
                month_revenue_10
                month_revenue_11
                month_revenue_12
                total_year_revenue
                type_revenue_actual_1
                month_revenue_actual_1
                month_revenue_actual_2
                month_revenue_actual_3
                month_revenue_actual_4
                month_revenue_actual_5
                month_revenue_actual_6
                month_revenue_actual_7
                month_revenue_actual_8
                month_revenue_actual_9
                month_revenue_actual_10
                month_revenue_actual_11
                month_revenue_actual_12
                total_year_revenue_actual
                month_percent_1
                month_percent_2
                month_percent_3
                month_percent_4
                month_percent_5
                month_percent_6
                month_percent_7
                month_percent_8
                month_percent_9
                month_percent_10
                month_percent_11
                month_percent_12
                total_year_percent
            }
            total_month_revenue_1
            total_month_revenue_2
            total_month_revenue_3
            total_month_revenue_4
            total_month_revenue_5
            total_month_revenue_6
            total_month_revenue_7
            total_month_revenue_8
            total_month_revenue_9
            total_month_revenue_10
            total_month_revenue_11
            total_month_revenue_12
            total_year_revenue
            total_month_revenue_actual_1
            total_month_revenue_actual_2
            total_month_revenue_actual_3
            total_month_revenue_actual_4
            total_month_revenue_actual_5
            total_month_revenue_actual_6
            total_month_revenue_actual_7
            total_month_revenue_actual_8
            total_month_revenue_actual_9
            total_month_revenue_actual_10
            total_month_revenue_actual_11
            total_month_revenue_actual_12
            total_revenue_year_actual
            total_month_percent_1
            total_month_percent_2
            total_month_percent_3
            total_month_percent_4
            total_month_percent_5
            total_month_percent_6
            total_month_percent_7
            total_month_percent_8
            total_month_percent_9
            total_month_percent_10
            total_month_percent_11
            total_month_percent_12
            total_year_percent
       }
       profit_tax{
            revenue_plant{
                plant_name
                team_sales_id
                team_name
                type_revenue
                month_revenue_1
                month_revenue_2
                month_revenue_3
                month_revenue_4
                month_revenue_5
                month_revenue_6
                month_revenue_7
                month_revenue_8
                month_revenue_9
                month_revenue_10
                month_revenue_11
                month_revenue_12
                total_year_revenue
                type_revenue_actual_1
                month_revenue_actual_1
                month_revenue_actual_2
                month_revenue_actual_3
                month_revenue_actual_4
                month_revenue_actual_5
                month_revenue_actual_6
                month_revenue_actual_7
                month_revenue_actual_8
                month_revenue_actual_9
                month_revenue_actual_10
                month_revenue_actual_11
                month_revenue_actual_12
                total_year_revenue_actual
                month_percent_1
                month_percent_2
                month_percent_3
                month_percent_4
                month_percent_5
                month_percent_6
                month_percent_7
                month_percent_8
                month_percent_9
                month_percent_10
                month_percent_11
                month_percent_12
                total_year_percent
            }
            total_month_revenue_1
            total_month_revenue_2
            total_month_revenue_3
            total_month_revenue_4
            total_month_revenue_5
            total_month_revenue_6
            total_month_revenue_7
            total_month_revenue_8
            total_month_revenue_9
            total_month_revenue_10
            total_month_revenue_11
            total_month_revenue_12
            total_year_revenue
            total_month_revenue_actual_1
            total_month_revenue_actual_2
            total_month_revenue_actual_3
            total_month_revenue_actual_4
            total_month_revenue_actual_5
            total_month_revenue_actual_6
            total_month_revenue_actual_7
            total_month_revenue_actual_8
            total_month_revenue_actual_9
            total_month_revenue_actual_10
            total_month_revenue_actual_11
            total_month_revenue_actual_12
            total_revenue_year_actual
            total_month_percent_1
            total_month_percent_2
            total_month_percent_3
            total_month_percent_4
            total_month_percent_5
            total_month_percent_6
            total_month_percent_7
            total_month_percent_8
            total_month_percent_9
            total_month_percent_10
            total_month_percent_11
            total_month_percent_12
            total_year_percent
       }
    }
}`;
